import { mainMenuDefaultItemsFactory } from './constants.js';
export const getDeprecatedItemsCleaner = (intl) => {
    const defaultItems = mainMenuDefaultItemsFactory(intl);
    return (items) => {
        if (!(items === null || items === void 0 ? void 0 : items.length)) {
            return [...defaultItems];
        }
        return items
            .filter(item => item.spaceSlug !== `default::explore` &&
            item.spaceSlug !== 'explore' &&
            item.page !== 'explore')
            .map(item => (Object.assign(Object.assign({}, item), { action: item.action === 'OPEN_PAGE' ? 'OPEN_SPACE' : item.action, spaceSlug: item.spaceSlug || `default::${item.page}` })));
    };
};
//# sourceMappingURL=utils.js.map